/* Folliva Clear · fc-progress: the drag line, the case thumbnails and a one-time "you can drag this" hint. */
(function () {
  function init(root) {
    if (!root || root.__fcpr) return; root.__fcpr = true;
    var stage = root.querySelector('.fcpr__stage'), range = root.querySelector('.fcpr__range');
    if (!stage || !range) return;
    function setPos(v) { stage.style.setProperty('--pos', v + '%'); }
    range.addEventListener('input', function () { stage.classList.remove('is-hint'); setPos(range.value); });
    /* drag anywhere on the photo (touch included); vertical swipes still scroll the page (touch-action: pan-y) */
    var dragging = false;
    function fromX(x) { var r = stage.getBoundingClientRect(); var v = Math.max(0, Math.min(100, (x - r.left) / r.width * 100)); range.value = Math.round(v); setPos(v.toFixed(1)); }
    stage.addEventListener('pointerdown', function (e) { if (e.pointerType === 'mouse' && e.button !== 0) return; dragging = true; stage.classList.remove('is-hint'); try { stage.setPointerCapture(e.pointerId); } catch (x) {} fromX(e.clientX); });
    stage.addEventListener('pointermove', function (e) { if (dragging) fromX(e.clientX); });
    ['pointerup', 'pointercancel', 'lostpointercapture'].forEach(function (t) { stage.addEventListener(t, function () { dragging = false; }); });
    root.querySelectorAll('[data-fcpr-pick]').forEach(function (b) {
      b.addEventListener('click', function () {
        var i = b.getAttribute('data-fcpr-pick');
        root.querySelectorAll('[data-fcpr-pair]').forEach(function (p) { p.classList.toggle('is-on', p.getAttribute('data-fcpr-pair') === i); });
        root.querySelectorAll('[data-fcpr-info]').forEach(function (p) { p.classList.toggle('is-on', p.getAttribute('data-fcpr-info') === i); });
        root.querySelectorAll('[data-fcpr-pick]').forEach(function (t) { var on = t === b; t.classList.toggle('is-on', on); t.setAttribute('aria-selected', on ? 'true' : 'false'); });
        var img = root.querySelectorAll('[data-fcpr-pair="' + i + '"] img'); img.forEach(function (x) { x.loading = 'eager'; });
        range.value = 50; setPos(50);
      });
    });
    var reduce = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (reduce || !root.classList.contains('fcpr--hint') || !('IntersectionObserver' in window)) return;
    var done = false;
    new IntersectionObserver(function (es, io) {
      es.forEach(function (e) {
        if (e.isIntersecting && !done) { done = true; stage.classList.add('is-hint'); setTimeout(function () { stage.classList.remove('is-hint'); }, 2600); io.disconnect(); }
      });
    }, { threshold: .6 }).observe(stage);
  }
  function boot() { document.querySelectorAll('[data-fcpr]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', function (e) { var r = e.target && e.target.querySelector('[data-fcpr]'); if (r) init(r); });
})();
